<template>
  <div class="service-request-page-step__wrapper">
    <div class="service-request-page-step__fields">
      <BaseSelectNew
        v-model="form.service_id"
        :required="!!getMain.form.service_id.required"
        :items="serviceItemsLoader()"
        :label="getMain.form.service_id.label"
        :placeholder="getMain.form.service_id.placeholder"
        :errorMsg="errorMsgs.service_id"
        class="service-request-page__form-input"
        :autoSelect="true"
        :disabled="queryServiceValid"
        :hideArrow="queryServiceValid"
        @input="serviceChange"

      />
      <BaseSelectNew
        v-if="serviceSubItemsPrepared.length"
        v-model="form.sub_service_id"
        :required="true"
        :items="serviceSubItemsPrepared"
        :label="getMain.form.sub_service_id.label"
        :placeholder="getMain.form.sub_service_id.placeholder"
        :errorMsg="errorMsgs.sub_service_id"
        class="service-request-page__form-input"
        :autoSelect="true"
      />
      <BaseDatePickerNew
        ref="datePicker"
        :label="getMain.form.date_time.label"
        :required="getMain.form.date_time.required"
        :buttonsText="getMain.form.date_time.buttonText"
        :options="datePickerOptions"
        :errorMsg="errorMsgs.date_time"
        :class="['service-request-page__form-input']"
        :requestServiceIn="requestServiceIn"
        :workPeriod="workPeriod"
        :globalTime="time"
        :changeTime="changeTime"
        @input="form.date_time = $event"
      />
      <BaseSelectNew
        v-model="form.mobility_id"
        :items="moboiltiesItems"
        :label="getMain.form.mobility_id.label"
        :placeholder="getMain.form.mobility_id.placeholder"
        :required="!!getMain.form.mobility_id.required"
        :errorMsg="errorMsgs.mobility_id"
        :autoSelect="true"
        class="service-request-page__form-input-mobility"
      />
    </div>
    <div v-if="getMain.hintText" class="service-request-page__editor-wrapper">
      <p class="service-request-page__editor" v-html="getMain.hintText" />
    </div>
    <BaseButton
      class="service-request-page__button"
      type="primary"
      :disabled="!serviceSubItemsPrepared.length ? (!form.service_id || (getMain.form.date_time.required && !form.date_time) || !form.mobility_id) :(!form.service_id || (getMain.form.date_time.required && !form.date_time) || !form.mobility_id || !form.sub_service_id) "
      @click="submitForm"
    >
      {{ getMain.continueButtonText }}
    </BaseButton>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'

  export default {
    name: 'Step2',

    components: { IconArrow },
    props: {
      form: [Object, String],
      dealerItems: Array,
      title: String,
      hint: String,
      showroom: String,
      errorMsgs: Object,
      submitForm: Function,
      requestServiceIn: Number,
      workPeriod: [Function, Object],
      time: String,
      changeTime: Function,
      moboiltiesItems: Array,
      dealerServices: Array,
      currentStepIndex: Number,
      onServiceChanged: Function
    },
    data () {
      return {
        error: false,
        language: this.$store.state.currentLang,
        country: this.$store.state.currentCountry
      }
    },
    computed: {
    ...mapGetters(['getMain', 'isShow', 'getPhoneType']),
    ...mapState({
      currentLang: state => state.currentLang,
      currentCountry: state => state.currentCountry
    }),
      queryService () {
        return this.$route.query.service
      },

      queryServiceValid () {
        if (!this.queryService) return false

        return this.serviceItems.some(
          item => String(item.value) === String(this.queryService)
        )
      },
      serviceItems () {
        let items = (this.getMain && this.getMain.form.service_id.items) || []

        if (!this.dealerServices || !this.dealerServices.length) return items

        const dealerServiceIds = this.dealerServices.map(s => s.id)

        items = items
          .filter(item => dealerServiceIds.includes(item.value))
          .sort((a, b) => dealerServiceIds.indexOf(a.value) - dealerServiceIds.indexOf(b.value))

        return items
      },
      subServiceItems () {
        const items = (this.getMain && this.getMain.form.sub_service_id.items) || []

        if (!this.dealerServices || !this.dealerServices.length) return []

        const service = this.dealerServices.find(
          el => el.id === this.form.service_id
        )

        if (!service || !service.subServices) return []

        const lang = this.currentLang || 'ru'

        const subServicesMap = new Map(
          service.subServices.map(s => [s.id, s])
        )

        const filteredItems = items
          .filter(item => subServicesMap.has(+item.value))
          .map(item => {
            const subService = subServicesMap.get(+item.value)

            return {
              ...item,
              label:
                subService[`label_${lang}`]
            }
          })

        return filteredItems
      },
      datePickerOptions () {
        const dealerId = this.form.dealer_id
        let items = this.getMain.form.date_time.options

        this.dealerItems.forEach(({ value, workPeriod }) => {
          if (value === dealerId) {
            items = { datePickerStep: 60, schedule: workPeriod }
          }
        })
        return items
      },
      serviceSubItemsPrepared () {
        return this.subServiceItems.map(item => ({
          ...item,
          text: item.label
        }))
      }
    },
    methods: {
      serviceItemsLoader () {
        return this.serviceItems.map(item => (
          {
          ...item,
          text: item.label
          }
        ))
      },
      serviceChange () {
        this.form.sub_service_id = ''
        this.onServiceChanged()
      }
    }
  }
</script>

<style lang="scss">
.service-request-page-step {
  &__fields {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 24px;
    margin-bottom: 24px;

    .select {
      margin-bottom: 0 !important;
      min-width: 0 !important;
      padding-bottom: 0;
    }

    .datepicker {
      min-width: 0 !important;
      padding-bottom: 0;
    }

    @include tablet {
      grid-auto-flow: row;
      grid-auto-columns: auto;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      margin-bottom: 28px;

      .service-request-page__form-input-mobility {
        grid-column: auto;
      }
    }

    @include mobile {
      grid-template-columns: 1fr;
      gap: 16px;
      margin-bottom: 0;
    }
  }

  &__wrapper {
    .service-request-page__editor strong {
      font-weight: 400;
    }
  }
}

.service-request-page__button {
  margin-top: 15px;

  @include tablet {
    margin-top: 18px;
  }

  @include mobile {
    width: 100%;
  }
}
</style>
